import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var centerRoute = [{
  path: "",
  name: "center",
  component: function component() {
    return import("./center.vue");
  }
}];